import Vue from 'vue'

const DataStore = Vue.observable({

  App            : { version: process.env.VUE_APP_VERSION },
  Settings       : { domain: process.env.VUE_APP_DOMAIN },
  Data           : {
    CarBrands: [],
    CarModels: [],
  },
  MaintenanceMode: false
})

export default DataStore
